export const selectFrontendSettings = ({ frontendSettings }) => frontendSettings
